import dialogPdfImage from './dialogPdftoImage.vue'

export default {
  install: function (Vue) {
    const Construct = Vue.extend(dialogPdfImage)
    const Instance = new Construct({
		});
    Vue.prototype.$nextTick(()=> {
			Vue.prototype.$dialogPdftoImage = Instance.$mount()
      document.querySelector('.q-layout').appendChild(Instance.$el)
		})
  }
}
